module.exports = __webpack_public_path__ + "img/logo.6fb1a3bd.png";